import { render, staticRenderFns } from "./RequestsChart.vue?vue&type=template&id=3fb6a4f7"
import script from "./RequestsChart.vue?vue&type=script&lang=js"
export * from "./RequestsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports